import { bearlog } from "@sillyscribe95/bear-ui-web";
import React, { useEffect, useRef, useState, createContext } from "react";
import { chordKeyDict } from "../consts/chordConst";
import { instConst } from "../consts/instConst";
import {
  keyPlay,
  onChordMain,
  onKeyMain,
  playLong,
} from "../functions/keyPress";
import { getBaseNotes } from "../functions/noteFuncs";

export const MainContext = createContext();

const MainContextProvider = (props) => {
  //   1const
  const [tim, settim] = useState();

  // 1instrument

  let kdasdas =
    //
    // "Piano";
    "Guitar";
  // "Organ";
  // "Electric Piano";

  const [isnSound, setisnSound] = useState(kdasdas);
  const sifwas = instConst[isnSound]["midCode"];

  const reffo = useRef();
  const [keySound, setkeySound] = useState();
  const [picho, setpicho] = useState(0);
  const pitchPlus = ((12 + picho) % 12) + 1;
  const { chord: currChord } = chordKeyDict[pitchPlus];

  // 1notes
  let preNotes =
    //
    [];

  const [notesAll, setnotesAll] = useState(preNotes);
  const noteCurr = notesAll && notesAll[notesAll.length - 1];
  const noteBase = getBaseNotes(noteCurr);
  // const notePrev = notesAll && notesAll[notesAll.length -2];

  //   1pitch
  //   BOTTOM
  const sfweasd =
    //
    // -12;
    picho - 12;
  //   1;
  const topsao = sfweasd + 12;

  const [noteKey, setnoteKey] = useState();
  const [chordFull, setnoteChord] = useState();
  const noteChord =
    //
    // getBaseNotes(noteKey, picho);
    getBaseNotes(chordFull, picho);
  // chordFull && getBaseNotes(chordFull + picho);

  // 1chord
  function playChord(keyCode) {
    let asdsk = onChordMain(keyCode, sfweasd);

    playMain(asdsk);
    setnoteChord(asdsk);
  }

  function playChordMain(asdsk) {
    playMain(asdsk);
    setnoteChord(asdsk);
  }

  function playKey(keyCode) {
    let noteTrans = onKeyMain(keyCode, topsao);
    bearlog.lug("___ playKey ___", { keyCode, noteTrans });

    playMain(noteTrans);
    setnoteKey(noteTrans);
  }

  function playMain(keys) {
    //
    // 1notes
    let oksdas = [...notesAll, keys];
    setnotesAll(oksdas);
    bearlog.lug("___ oksdas ___", { sifwas, keys, reffo });

    setnotesAll(oksdas);
    keyPlay(sifwas, keys, reffo);
    // playLong(sifwas, keys, reffo);
  }

  function cutLong() {
    if (keySound) {
      keySound.cancel();
      setkeySound();
    }
  }

  // 1pitch
  function shiftpic(num) {
    // let num = adsfds;
    // bearlog.lug("___ adsfa ___", adsfds);
    let oaksdas = picho + num;
    bearlog.lug("___ oaksdas ___", oaksdas);
    setpicho(oaksdas);
  }

  // 1test
  const testTrue =
    //
    // "asqewe";
    "";
  //

  function testCheck(bitOne, bitTwo) {
    return testTrue ? bitOne : bitTwo;
  }

  // 1key
  const [overKeye = "Major", setoverKeye] = useState();

  // 1form
  const [viewType, setviewType] = useState();

  // 1console
  const baseScript = {
    note: {
      noteBase,
    },
    base: {
      //   hereo: hereo,
    },
    form: {
      //
    },
  };

  const okwe =
    //
    // ""
    "note";

  const osdre = okwe ? baseScript[okwe] : baseScript;

  bearlog.lug("___ osdre ___", osdre);

  const xvokbcv = {
    //
    overKeye,
    setoverKeye,
    pitchPlus,
    currChord,
    tim,
    settim,
    viewType,
    setviewType,
    testCheck,
    isnSound,
    setisnSound,
    reffo,
    playChord,
    playKey,
    playChordMain,
    shiftpic,
    playMain,
    picho,
    //
    //
    // 1notes
    notesAll,
    setnotesAll,
    noteCurr,
    noteBase,
    noteChord,
    // FORM
  };

  // 1return 1end
  return (
    <MainContext.Provider
      //
      value={xvokbcv}
    >
      {props.children}
    </MainContext.Provider>
  );
};
// }

export default MainContextProvider;
